import { alterarToken, alterarWhiteLabel } from "./../../actions/actions";
import { connect } from "react-redux";

import { useNavigate } from "react-router-dom";
import Button from "./../../components/button";

/**
 * @returns Um elemento de página de sucesso estilizado
 *
 * Componente de página de sucesso.
 */
const Success = (props: any) => {
  const navigate = useNavigate();
  console.log(props);
  //whitelabel
  const primaryColor = props.whitelabel.primaryColor
    ? props.whitelabel.primaryColor
    : "#182b8f";
  return (
    <>
      <div
        className="container w-11/12 mx-auto justify-content-center align-items-center pt-5 pb-5"
      >
        <div className="text-center">
          <h2 className="text-4xl font-semibold pb-4">Sucesso</h2>
          <p className="pb-4">Sua solicitação foi concluída!</p>
        </div>
        <div className="text-center">
          <Button
            name="Página Inicial"
            color={primaryColor}
            click={() => navigate(`/`)}
            disabled={false}
          />
        </div>
      </div>
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    alterarTokenItens(novoNumero: any) {
      const action = alterarToken(novoNumero);
      dispatch(action);
    },
    alterarWhitelabel(whitelabel: any) {
      const action = alterarWhiteLabel(whitelabel);
      dispatch(action);
    },
  };
};

function mapStateToProps(state: any) {
  return {
    whitelabel: state.whiteLabel,
    session: state.session,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Success);
